import React from "react";
import { Container, MainLayout, MainContent, Sidebar, SectionTitle, SectionDescription } from "../styles/primitives";

const ApplicationLayout = ({ 
    title, 
    description, 
    children, 
    sidebarContent 
}) => {
    return (
        <Container>
            {(title || description) && (
                <div>
                    {title && <SectionTitle>{title}</SectionTitle>}
                    {description && <SectionDescription>{description}</SectionDescription>}
                </div>
            )}
            <MainLayout $hasSidebar={Boolean(sidebarContent)}>
                <MainContent>
                    {children}
                </MainContent>
                {sidebarContent && (
                    <Sidebar>
                        {sidebarContent}
                    </Sidebar>
                )}
            </MainLayout>
        </Container>
    );
};

export default ApplicationLayout;

